<template>
  <section
    v-if="
      selectedProduct.parent_id && allProducts.length > 1 && tableData.length
    "
    class="mt-6 pt-6 md:mt-8 md:pt-8 border-t border-border"
    v-cloak
  >
    <!-- Cabecera -->
    <div class="flex items-center justify-between md:mb-8 mb-4">
      <h2 class="text-2xl font-bold text-text-main">
        {{ transPeralbaPro.item1301 }}
      </h2>
      <div class="flex items-center gap-2">
        <span v-if="!showAllVariants" class="text-sm text-text-secondary">
          {{ transPeralbaPro.item1302 }} {{ Math.min(tableData.length, 5) }} de
          {{ tableData.length }} {{ transPeralbaPro.item1301.toLowerCase() }}
        </span>
        <span v-else class="text-sm text-text-secondary">
          {{ transPeralbaPro.item1302 }} {{ transPeralbaPro.item1303 }}
        </span>
      </div>
    </div>

    <div
      class="border border-border rounded-lg overflow-hidden bg-white shadow-sm"
      v-if="tableData.length"
    >
      <div class="overflow-x-auto">
        <table class="w-full text-sm text-left">
          <thead
            class="bg-surface border-b border-border text-xs uppercase text-text-secondary font-semibold"
          >
            <tr>
              <th align="center" class="px-6 py-4">
                {{ transPeralbaPro.item619 }}
              </th>
              <th class="px-4 py-4 w-px whitespace-nowrap">
                {{ transPeralbaPro.item601 }}
              </th>
              <th class="px-6 py-4 min-w-[200px]">
                {{ transPeralbaPro.item821 }}
              </th>
              <th
                align="center"
                v-for="attr in variations"
                :key="attr.attribute_id"
                class="px-6 py-4"
              >
                {{ attr.name }}
              </th>
              <th align="center" class="px-6 py-4">
                {{ transPeralbaPro.item903 }}
              </th>
              <th align="center" class="px-6 py-4 min-w-[150px]">
                {{ transPeralbaPro.item38 }}
              </th>
              <th class="px-6 py-4 text-align"></th>
            </tr>
          </thead>

          <tbody class="divide-y divide-border">
            <tr
              v-for="item in visibleVariants"
              class="cursor-pointer"
              @click="selectVariantFromTable(item)"
              :key="item.product_code"
              :class="
                isSelectedVariant(item)
                  ? 'group bg-primary-50 ring-2 ring-primary ring-inset relative z-10'
                  : 'group hover:bg-primary-50/20 transition-colors bg-white'
              "
            >
              <td align="center" class="px-6 py-4">
                <div
                  class="size-12 bg-white border border-primary rounded flex items-center justify-center overflow-hidden"
                >
                  <img
                    loading="lazy"
                    :src="
                      item.images[currentImageIndex]
                        ? item.images[currentImageIndex].image
                        : item.images[0].image
                    "
                    :alt="item.name"
                  />
                </div>
              </td>

              <td class="px-4 py-4 w-px whitespace-nowrap">
                <span class="text-text-secondary font-medium">
                  {{ item.product_code }}
                </span>
              </td>

              <td class="px-6 py-4">
                <div
                  class="font-bold text-text-main group-hover:text-primary transition-colors"
                >
                  {{ item.name }}
                </div>
              </td>

              <td
                align="center"
                v-for="attr in variations"
                :key="attr.attribute_id"
                class="px-6 py-4 text-text-main"
              >
                {{ item.variations[attr.name] }}
              </td>

              <td align="center" class="px-6 py-4 whitespace-nowrap">
                <div class="flex flex-col">
                  <template v-if="item.discount != '0,00'">
                    <div class="flex items-center gap-2">
                      <span class="text-xs text-text-secondary line-through"
                        >{{ item.price_without_discount }} €</span
                      >
                      <span
                        class="text-[10px] font-bold text-red-600 bg-red-100 px-1 rounded"
                        >-{{ item.discount }}%</span
                      >
                    </div>
                    <span class="text-lg font-bold text-primary"
                      >{{ item.netprice }} €</span
                    >
                  </template>
                  <template v-else>
                    <span class="text-lg font-bold text-text-main"
                      >{{ item.price_without_discount }} €</span
                    >
                  </template>
                </div>
              </td>

              <td align="center" class="px-6 py-4">
                <div class="relative flex items-center w-[120px]">
                  <button
                    type="button"
                    class="bg-surface hover:bg-gray-200 border border-border rounded-l p-1 h-9 flex items-center justify-center focus:outline-none transition-colors w-8"
                    :class="{
                      'opacity-50 cursor-not-allowed':
                        Number(item.quantity) <=
                        (Number(item.minimum) > 0 ? Number(item.minimum) : 1),
                    }"
                    @click.stop="decreaseQuantity(item)"
                  >
                    <span class="text-lg leading-none select-none">−</span>
                  </button>

                  <input
                    type="number"
                    class="bg-white border-y border-x-0 border-border h-9 text-center text-text-main text-sm w-full focus:ring-0 focus:outline-none [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
                    :min="item.minimum > 0 ? item.minimum : 1"
                    max="10000"
                    :step="item.minimum > 0 ? item.minimum : 1"
                    v-model.number="item.quantity"
                    @click.stop
                    @focus="$event.target.select()"
                    @change="normalizeQuantity(item)"
                  />

                  <button
                    type="button"
                    class="bg-surface hover:bg-gray-200 border border-border rounded-r p-1 h-9 flex items-center justify-center focus:outline-none transition-colors w-8"
                    @click.stop="increaseQuantity(item)"
                  >
                    <span class="text-lg leading-none select-none">+</span>
                  </button>
                </div>
              </td>

              <td align="center" class="px-6 py-4">
                <button
                  type="button"
                  :title="transPeralbaPro.item896"
                  @click.prevent.stop="addToCart(item)"
                  class="size-8 rounded-full flex items-center justify-center transition-all shadow-sm border border-transparent"
                  :class="
                    isSelectedVariant(item)
                      ? 'bg-primary text-white border-primary'
                      : 'text-primary bg-surface hover:bg-primary hover:text-white hover:border-primary'
                  "
                >
                  <vue-icon name="add_shopping_cart" class="text-[18px]" />
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div
        v-if="tableData.length > 5"
        class="bg-surface border-t border-border px-6 py-3 flex justify-center"
      >
        <button
          type="button"
          @click="showAllVariants = !showAllVariants"
          class="text-sm font-semibold text-primary hover:text-primary-dark transition-colors flex items-center gap-2 group px-4 py-2 rounded-lg hover:bg-primary-50 focus:outline-none"
        >
          <span v-if="!showAllVariants">
            {{ transPeralbaPro.item1329 }} ({{ tableData.length - 5 }}
            {{ transPeralbaPro.item1330 }})
          </span>
          <span v-else>
            {{ transPeralbaPro.item1326 }}
          </span>

          <vue-icon
            name="expand_more"
            class="text-[18px] transition-transform duration-300"
            v-bind:class="{'rotate-180': showAllVariants}"
          />
        </button>
      </div>
    </div>

    <div
      class="flex items-center gap-2 text-sm text-text-secondary bg-gray-50 p-3 rounded border border-border inline-flex mb-8"
      v-if="
        selectedProduct.last_purchase_date != null &&
          selectedProduct.last_purchase_date != ''
      "
    >
      <i class="fas fa-calendar-check text-primary"></i>
      <span
        >Última compra:
        <strong>{{ selectedProduct.last_purchase_date }}</strong></span
      >
    </div>
  </section>
</template>

<script>
export default {
  name: "TableVariants",
  emits: [
    "select-variant",
    "decrease-quantity",
    "increase-quantity",
    "normalize-quantity",
    "add-to-cart",
  ],
  props: {
    selectedProduct: {
      type: Object,
      required: true,
    },
    noImagePath: {
      type: String,
      default: "/front/img/product_images/no-image.jpg",
    },
    // Afegit: Tots els productes (necessari per a allProducts.length > 1)
    allProducts: {
      type: Array,
      required: true,
      default: () => [],
    },
    // Afegit: Les dades de la taula (la llista de variants a mostrar)
    tableData: {
      type: Array,
      required: true,
      default: () => [],
    },
    // Afegit: Atributs/Variacions per generar les columnes dinàmiques
    variations: {
      type: Array,
      required: true,
      default: () => [],
    },
    // Afegit: Traduccions
    transPeralbaPro: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  data() {
    return {
      currentImageIndex: 0,
      showAllVariants: false, // Afegit: Necessari per controlar si es mostren més de 5 files o no
    };
  },

  computed: {
    /**
     * Retorna la llista de variants a mostrar depenent de si
     * l'usuari ha clicat a "Veure més" o no.
     */
    visibleVariants() {
      if (this.showAllVariants) {
        return this.tableData;
      }
      return this.tableData.slice(0, 5);
    },
  },
  watch: {
    selectedProduct() {
      this.currentImageIndex = 0;
    },
    tableData() {
      this.showAllVariants = false;
    },
  },
  methods: {
    /**
     * Comprova si una fila és la mateixa que la que tenim seleccionada
     * (Per marcar-la de color diferent)
     */
    isSelectedVariant(item) {
      return (
        this.selectedProduct.erp_reference === item.product_code ||
        this.selectedProduct.alias_code === item.product_code
      );
    },

    /**
     * Selecciona una variant des de la taula (avisem al pare)
     */
    selectVariantFromTable(item) {
      // Passem la feina al component pare
      this.$emit("select-variant", item);
    },

    /**
     * Disminueix la quantitat de l'ítem
     */
    decreaseQuantity(item) {
      // Passem la feina al component pare
      this.$emit("decrease-quantity", item);
    },

    /**
     * Augmenta la quantitat de l'ítem
     */
    increaseQuantity(item) {
      // Passem la feina al component pare
      this.$emit("increase-quantity", item);
    },

    /**
     * Quantitat escrita a ma: la puja al multiple de venda mes proper
     * (ho fa el pare, resources/js/utils/quantity.js)
     */
    normalizeQuantity(item) {
      this.$emit("normalize-quantity", item);
    },

    /**
     * Afegeix la variant a la cistella de comprar (avisem al pare)
     */
    addToCart(item) {
      // Passem la feina al component pare
      this.$emit("add-to-cart", item);
    },
  },
};
</script>
